export const initialState = {}


// WEBPACK FOOTER //
// ./src/interface/store/departments/firestorm/selectors.js